import { render, staticRenderFns } from "./IncomeInvoice.vue?vue&type=template&id=6d607bd7&"
import script from "./IncomeInvoice.vue?vue&type=script&lang=js&"
export * from "./IncomeInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports